import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import LockIcon from "@material-ui/icons/Lock";
import * as Dati from "../../../Dati";
import * as Glob from "../../../Globale";
import { Trad } from "../../../components/";
import { _Autocomplete, _PasswordField, _Select } from "../../form/";
import { _PasswordChange } from "./PasswordChange";
import useToggle from "../../../hooks/Toggle";

interface IUserDetailsProps {
    Data: Dati.CDatiUtente;
    OnChange: (e: React.FormEvent<any> | string, val?: unknown) => void;
    SetDialog: (v: Glob.CDialog) => void;
}

export const _UserDetails: React.FC<IUserDetailsProps> = ({ Data, OnChange, SetDialog }) => {
    const { open, toggle } = useToggle();
    const languages: Dati.TDictTipo = {};
    languages["IT"] = new Dati.CTipo("IT", "Italiana");
    languages["EN"] = new Dati.CTipo("EN", "Inglese");

    const isFormDisabled = Data.ID_Utente > 0;

    return (
        <Card>
            <CardHeader title={Trad.Trad("Dettagli utente")} titleTypographyProps={{ variant: "h6" }} />
            <CardContent>
                <form noValidate>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={2}>
                            <TextField value={Data.ID_Utente} id="ID_Utente" label={Trad.Trad("ID")} disabled fullWidth />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <_Autocomplete
                                Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                Value={Data.ID_Anag.toString()}
                                Name="ID_Anag"
                                Label="Anagrafica"
                                OnChange={OnChange}
                                Disabled={isFormDisabled}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField
                                value={Data.Login ?? ""}
                                id="Login"
                                label={Trad.Trad("Login")}
                                onChange={OnChange}
                                disabled={isFormDisabled}
                                inputProps={{ autoComplete: "new-login" }}
                                fullWidth
                            />
                        </Grid>
                        {!isFormDisabled && (
                            <Grid item xs={12} md={3}>
                                <_PasswordField Value={Data.Password ?? ""} Disabled={isFormDisabled} OnChange={OnChange} />
                            </Grid>
                        )}
                        {isFormDisabled && (
                            <Grid item xs={2}>
                                <Tooltip title={Trad.Trad("Change password")}>
                                    <IconButton onClick={toggle} aria-label="change password" color="secondary" size="small">
                                        <LockIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        )}
                        <Grid item xs={12} md={2}>
                            <TextField value={Data.Livello} id="Livello" label={Trad.Trad("Livello")} onChange={OnChange} type="number" InputProps={{ inputProps: { min: 1, max: 10 } }} fullWidth />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField value={Data.Email ?? ""} id="Email" label={Trad.Trad("Email")} onChange={OnChange} fullWidth />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField value={Data.Nome ?? ""} id="Nome" label={Trad.Trad("Nome")} onChange={OnChange} fullWidth />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField value={Data.Cognome ?? ""} id="Cognome" label={Trad.Trad("Cognome")} onChange={OnChange} fullWidth />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <_Select Value={Data.LinguaNotifiche ?? "IT"} Name="LinguaNotifiche" Label="LinguaNotifiche" OnChange={OnChange} Options={languages} />
                        </Grid>
                    </Grid>
                </form>
                <_PasswordChange Open={open} SetDialog={SetDialog} UserId={Data.ID_Utente} OnClose={toggle} />
            </CardContent>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/User/UserDetails.tsx